import { assetmanagerAPI } from 'utils/assetmanagerUtils'
import { Action } from 'types/redux'
import * as actions from './actions'

type optionsType = {
  hideSuccessMsg?: boolean
}

export function assetmanagerBulkUpload(params = {}): Action {
  return {
    type: actions.ASSETMANAGER_BULK_UPLOAD,
    payload: assetmanagerAPI('/v1/bulk_upload', params, 'GET'),
  }
}

export function assetmanagerBulkUploadCategoriesLoad(params = {}, baseUrl?: string): Action {
  return {
    type: actions.ASSETMANAGER_BULK_UPLOAD_GROUPED_BY_CAT_LOAD,
    payload: assetmanagerAPI('/v1/bulk_upload/categories', params, 'GET', null, baseUrl),
  }
}

export function assetmanagerBulkUploadImportPost(
  data = {},
  params = {},
  options?: optionsType,
): Action {
  return {
    type: actions.ASSETMANAGER_BULK_UPLOAD_IMPORT_POST,
    payload: new Promise((resolve, reject) => {
      assetmanagerAPI('/v1/bulk_upload', params, 'POST', data)
        ?.then((response) => resolve({ options, ...response }))
        .catch((err) => reject(err))
    }),
  }
}

export function resetAssetmanagerBulkUploadImport(): Action {
  return {
    type: actions.RESET_ASSETMANAGER_BULK_UPLOAD_IMPORT,
  }
}
